import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useApiCall from '../../../../hooks/useApiCall';
import useGetGeneralAppData from '../../../../hooks/useGetGeneralAppData';
import authService from '../../../../services/authService';

interface UseHandleSubmitInterface {
  currentPassword: string;
  newPassword: string;
}

export default function useHandleSubmit({
  currentPassword,
  newPassword,
}: UseHandleSubmitInterface) {
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const { apiCall } = useApiCall();
  const { userCode, userProfile, usersCompanyCode } = useGetGeneralAppData();

  const handleSubmit = useCallback(async () => {
    await apiCall({
      apiToCall: authService.changePasswordLogged,
      reqBody: JSON.stringify({
        codUsu: userCode,
        perfilUsu: userProfile,
        codEmpresa: usersCompanyCode,
        senhaAtual: currentPassword,
        senhaNova: newPassword,
      }),
      onStartLoad: () => setIsLoading(true),
      onEndLoad: () => setIsLoading(false),
      actionAfterResponse: (apiResponse) => {
        if (!apiResponse.codigo) {
          toast.error(`Não foi possível alterar a senha. Por favor, tente novamente (${apiResponse.msg})`);
          setIsLoading(false);
          return;
        }
        toast.success('Senha alterada com sucesso!');
        navigate('/');
      },
      catchMessage: 'Não foi possível alterar a senha. Por favor, tente novamente',
    });
  }, [apiCall, currentPassword, navigate, newPassword, userCode, userProfile, usersCompanyCode]);

  return { handleSubmit, isLoading };
}
